import React, { useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { Visibility } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';
import { enqueueErrorSnackbar } from '../../../actions/Notifications';
import { usePreviewOpener } from '../../shell/preview/usePreviewOpener';

/**
 * PreviewButton - Opens shop with ?kea-preview=true parameter
 * Handles redirect detection automatically (like in onboarding)
 */
export default function PreviewButton({ disabled, variant = 'outlined', ...buttonProps }) {
  const localizeMessage = useLocalizedMessage();
  const dispatch = useDispatch();
  const [isResolving, setIsResolving] = useState(false);
  const { canOpenPreview, openStorefrontPreview } = usePreviewOpener();

  const handleClick = async () => {
    if (!canOpenPreview) {
      return;
    }

    setIsResolving(true);
    try {
      await openStorefrontPreview();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to open preview:', error);
      dispatch(enqueueErrorSnackbar(error?.message || localizeMessage('search.preview.openFailed')));
    } finally {
      setIsResolving(false);
    }
  };

  return (
    <Button
      variant={variant}
      startIcon={isResolving ? <CircularProgress size={20} /> : <Visibility />}
      disabled={disabled || isResolving || !canOpenPreview}
      onClick={handleClick}
      {...buttonProps}
    >
      {localizeMessage('searchInterface.build.preview')}
    </Button>
  );
}
